module.exports = __webpack_public_path__ + "static/media/icon_shop.e9f2d7f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_shop.svg
// module id = 707
// module chunks = 0